'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z' });

var Beenhere = function Beenhere(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Beenhere = (0, _pure2.default)(Beenhere);
Beenhere.muiName = 'SvgIcon';

exports.default = Beenhere;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Beenhere.js
// module id = 2167
// module chunks = 0